import { render } from "./ReportsAndAnalytics.vue?vue&type=template&id=70525afe&scoped=true"
import script from "./ReportsAndAnalytics.vue?vue&type=script&lang=js"
export * from "./ReportsAndAnalytics.vue?vue&type=script&lang=js"

import "./ReportsAndAnalytics.vue?vue&type=style&index=0&id=70525afe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70525afe"]])

export default __exports__